<template>
  <div class="cal-elec">
    <map-control
      v-if="windfarmId"
      :icon="threeD"
      title="3D"
      @click="show3D"
    ></map-control>
  </div>
</template>

<script>
import threeD from '@/asset/3d.svg';
import MapControl from './map-control';

export default {
  components: {
    MapControl
  },
  data() {
    return {
      threeD,
      windfarmId: sessionStorage.getItem('farmId')
    };
  },
  methods: {
    show3D() {
      this.windfarmId = sessionStorage.getItem('farmId');
      if (!this.windfarmId) {
        this.$message.warn('请选择一个风场');
        return;
      }
      location.href = `/3d.html?windfarmId=${this.windfarmId}`;
      //  let that = this;
      //   this.$fetch
      //     .get('/windfarm/windfarm/getFarmModel3D', {
      //       showError: true,
      //       params: {
      //         windfarmId: that.windfarmId
      //       }
      //     })
      //     .then(res => {
      //       /*
      //       to do:
      //       1、目前由于访问的是示例文件，且只有98号风场所以url是写死的，需要更换为动态的windfarmId
      //       2、3d图标只有进入风场才显示，这个显示的控制需要看下
      //        */
      //       if (res.code === 0)
      //          window.location = '/model3d/projectdata/'+this.windfarmId+'/wind_turbine.html';
      //     })
    }
  },
  mounted() {
    window.addEventListener('setItem', () => {
      this.windfarmId = sessionStorage.getItem('farmId');
    });
  }
};
</script>

<style lang="less" scoped>
.cal-elec {
  position: absolute;
  z-index: 1000;
  bottom: 132px;
  right: 10px;

  /deep/.map-control {
    img {
      width: 100%;
      width: 100%;
    }
  }
}
</style>
